import { graphConfig } from './auth365Config'

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export function callMsGraph(accessToken) {
  const headers = new Headers()
  const bearer = `Bearer ${accessToken}`

  headers.append('Authorization', bearer)

  const options = {
    method: 'GET',
    headers,
  }

  return fetch(graphConfig.graphMeEndpoint, options)
    .then(response => response.json())
    .catch(error => console.log(error))
}
export function callMsGraphPhoto(accessToken) {
  const headers = new Headers()
  const bearer = `Bearer ${accessToken}`

  headers.append('Authorization', bearer)

  const options = {
    method: 'GET',
    headers,
  }

  return fetch(`${graphConfig.graphMeEndpoint}/photo/$value`, options)
  // .then(response => response)
    .then((response) => {
      if (!response.ok) {
        return null
      }
      return response.arrayBuffer()
    })
    .catch(error => console.log(error))
}



// WEBPACK FOOTER //
// ./src/graph.js